export function collectionPrerequisite(sessions:readonly unknown[],participants:readonly {archived?:boolean|number}[]):'session'|'participant'|null {
 if(!sessions.length)return 'session'
 if(!participants.some(p=>!p.archived))return 'participant'
 return null
}

// Only temporary transport failures may use an existing local permission lease.
export function capturePreparationMayRecover(error: unknown): boolean {
 const failure=error as {code?:string;status?:number}|null
 return (!failure?.status && failure?.code==='NETWORK_ERROR') || failure?.status===408 || failure?.status===429 ||
  (typeof failure?.status==='number' && failure.status>=500 && failure.status<600)
}
